/**
 * Centralized Google Analytics 4 event tracking utility.
 * GA is loaded globally via gtag.js in public/index.html.
 */

declare function gtag(...args: unknown[]): void;

export const trackEvent = (
  eventName: string,
  params?: Record<string, unknown>
): void => {
  if (typeof gtag === "function") {
    gtag("event", eventName, params ?? {});
  }
};

// ─── Event Name Constants ────────────────────────────────────────────────────

export const GA_EVENTS = {
  // Navigation
  PAGE_VIEW_HOME: "page_view_home",
  PAGE_VIEW_APP: "page_view_app",
  CLICK_START_DESIGNING: "click_start_designing",

  // Canvas
  BLOCK_ADDED: "block_added",
  BLOCK_DELETED: "block_deleted",
  CONNECTION_ADDED: "connection_added",
  CONNECTION_DELETED: "connection_deleted",

  // Game controls
  GAME_STARTED: "game_started",
  GAME_PAUSED: "game_paused",
  GAME_RESUMED: "game_resumed",

  // IOPS Config Modal
  IOPS_MODAL_OPENED: "iops_modal_opened",
  IOPS_CONFIG_SAVED: "iops_config_saved",
  TRAFFIC_PATTERN_CHANGED: "traffic_pattern_changed",
} as const;
